module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isGroupPushed) { ;
__p += '\n    <span class="current-group-status">\n        <i class="glyphicon glyphicon-exclamation-sign important not-pushed-changes-warning" data-content="The current version of this Group is Not Pushed."></i>\n        <span class="pushed-check-mark">&#10003;</span>\n        <span class="readable-state"></span>\n    </span>\n';
 } ;
__p += '\n\n';
 if (isOneUnit) { ;
__p += '\n<div class="group-data-section ' +
__e(groupType ) +
'">\n    <div class="toggle-group-data';
 if (isGroupPushed) { ;
__p += ' toggle-title open';
};
__p += '">Group Data</div>\n    <div class="assigned-breakpoints-container">\n        <ul class="breakpoints-flex-section list-unstyled">\n            ';
 _.each(assets, function(asset, index) { ;
__p += '\n                <li class="breakpoint-flex-item">\n                    <div class="interval-indicator ' +
__e( asset[0] ) +
'">' +
__e( asset[0] ) +
'</div>\n                    <div class="variant-name">' +
__e( asset[2].get("name") ) +
'</div>\n                    <div class="breakpoint-value">' +
__e( asset[1].get('threshold') ) +
' px</div>\n                </li>\n            ';
 }); ;
__p += '\n        </ul>\n    </div>\n</div>\n';
 } ;
__p += '\n\n';
 if (isGroupPushed && isOneUnit) { ;
__p += '\n    <div class="group-url-section">\n        <a href="#" class="toggle-group-url toggle-title\n            ';
 if (spectatorMode && !isGroupPushed) { ;
__p += '\n            disabled" data-content="The direct Group URL has not been enabled.\n            ';
 } else if (!isGroupPushed) { ;
__p += '\n            disabled" data-content="To get a direct Group URL open your Experience and click Push Group.\n            ';
 } ;
__p += '\n            ">Group URL</a>\n        <div class="group-url-container url-container"></div>\n    </div>\n';
 } ;
__p += '\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experienceOverview/QuickViewGroupDetailsView.tpl
// module id = 2879
// module chunks = 0